<template>
  <country-code-pane
    class="pwc-country-pane"
    :current="userInfo.countryCode"
    @select="handleSelectCountry"
  />
</template>

<script>
import CountryCodePane from '@/components/CountryCodePane'
import { mapActions, mapState } from 'vuex'
import Actions from '@/constants/action'
// import RouterName from '@/constants/route'

export default {
  components: {
    CountryCodePane
  },
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    ...mapActions({
      updateUserInfo: Actions.UPDATE_USER_LOCAL_INFO
    }),
    handleSelectCountry(country) {
      this.updateUserInfo(Object.assign({}, this.userInfo, {
        countryCode: country.code
      }))
      const query = this.$route.query
      this.$router.replace({
        path: query.form,
        query: query.params
      })
    }
  }
}
</script>
